import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Pages } from 'components/pages';
import { PermissionGuard } from 'components/permissions';
import Organizers from 'components/organizer';

const OrganizersRoute: React.FC = () =>
{

  return (
    <PermissionGuard
      permission={Organizers.Const.permissions.VIEW}
      fallback={<Pages.Page403 />}
    >
      <Routes>
        <Route path="/" element={<Pages.Organizers />} />
        <Route path="/:id/*" element={<Pages.Organizer />} />
        <Route path="/create/*" element={<Pages.Organizer />} />
      </Routes>
    </PermissionGuard>
  );
};


export default OrganizersRoute;
